import { Order, ORDER_STATUS } from 'types/api/order'
import { DeliveryShipment } from './delivery'

export interface DeliveriesForPlace extends Order {
  shipmentData: DeliveryShipment[]
  color: string
  routeIsInPlanning: boolean
  routeName: string
  orderStatus: ORDER_STATUS
  shipmentDeliveryTimes?: {
    startTime: string
    endTime: string
    deliveryDate: string
    shipmentStartTime: string | null
    shipmentEndTime: string | null
  }
  orderDeliveryTimes: {
    startTime: string
    endTime: string
    deliveryDate: string
  }
}

export enum DELIVERY_TYPE {
  HOME_DELIVERY = 'home-delivery',
  PICKUP = 'pickup',
}
